import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const Loader = () => {
  return (
    <Backdrop sx={{ color: '#fff' }} open={true}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Loader;
